import React from 'react';

const Game = ()=>{
return(
<>
<h1 className='gamePage'>Coming Soon...</h1>
</>)
}

export default Game;